import "./UpdateProfile.css";

// Firebase authentication
import Auth from "../../components/auth/auth";

import { useNavigate } from "react-router-dom";
import React, { useState } from "react";

import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase";
import { getAuth } from "firebase/auth";

const UpdateProfile = () => {
  const [Update, setUpdate] = useState("");
  const [DisableInput, setDisableInput] = useState(false);
  const [Error, setError] = useState(false);
  const navigate = useNavigate();

  const updateName = async () => {
    setDisableInput(true);
    const updateUserName = httpsCallable(functions, "updateUserName");
    let updatedData = {
      uid: getAuth().currentUser.uid,
      name: Update,
    };
    if ((await updateUserName(updatedData)) === true) {
      getAuth()
        .currentUser.reload()
        .then(() => {
          navigate("/user/dashboard");
          setDisableInput(false);
        });
    } else {
      // ...error
    }
  };

  return (
    <Auth title={"Update Profile"}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <p style={{ fontSize: "14px", color: "#7c7777" }}>
          Please enter your name to update your profile.
        </p>
      </div>
      <div class="form-group">
        <label>Name</label>
        <input
          style={{ height: "60px", backgroundColor: "#f5f5f5" }}
          type="text"
          placeholder="Enter Your Name Here"
          class="form-control input-style"
          value={Update}
          onChange={(e) => setUpdate(e.target.value)}
        />
      </div>
      {Error && <p>Invalid code</p>}

      <div class="text-center">
        <button
          style={{ height: "45px" }}
          type="button"
          class="btn btn-primary btn-block"
          onClick={updateName}
        >
          {DisableInput && (
            <span className="spinner-border spinner-border-sm mr-1"></span>
          )}
          Continue
        </button>
      </div>

      <div>
        <p
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            margin: "14px 0px 0px 0px",
          }}
        ></p>
      </div>
    </Auth>
  );
};

export default UpdateProfile;
